/* eslint camelcase: "off" */

import BaseAdapter from 'Core/adapters/base';

class PromotionCodeAdapter extends BaseAdapter {
  static get(code, price, photographerId) {
    let requestParams = {
      params: {
        code: code,
        price: price,
        photographer_id: photographerId
      }
    };

    return this.prototype.getRequest('/checkout/promotion', requestParams);
  }
}

export default PromotionCodeAdapter;



// WEBPACK FOOTER //
// ./app/assets/javascripts/adapters/promotionCode.js